export const envVars = {
  isDev: window._env_.REACT_APP_NODE_ENV === "development",
  isProd: window._env_.REACT_APP_NODE_ENV !== "development",
};

export function useEnvVars() {
  return envVars;
}
